import { useEffect, useState } from 'react'
import Translation from '../../Translation/cont/Translation'
import getSortItems from '../../../functions/getSortItems'
import MoviesFilterActions from '../presents/MoviesFilterActions'
import isEmptyObj from '../../../functions/isEmptyObj'

const MoviesFilterActionsContainer = ({
    filterConfig,
    listId, 
    dropStructureData = false, 
    relevantAttributes, 
    relevantMovies,
    currentMovies,
    futureMovies,
    selectedItems, 
    addItem, 
    deleteItem
}) => {
    const hasTargetOptions = false !== dropStructureData

    const defaultFilterValue = {
        id: 'all',
        name: <Translation id="alle_button" />,
        movies: relevantMovies
    }

    const initFilterState = {}
    
    filterConfig.map(({id}) => {
        initFilterState[id] = [defaultFilterValue]
    })

    const [filterOptions, setFilterOptions] = useState(initFilterState)

    const actionOptions = [
        { 
            id: 'add', 
            name: <Translation id="add_button" />
        },
        { 
            id: 'remove', 
            name: <Translation id="remove_button" />
        }
    ]

    useEffect(() => {
        const newOptions = {}

        filterConfig.map(({id}) => {

            if('period' === id) {
                newOptions[id] = [
                    defaultFilterValue,
                    {
                        name: <Translation id="section_filter_current_movies" />,
                        movies: currentMovies
                    },
                    {
                        name: <Translation id="section_filter_upcoming_movies" />,
                        movies: futureMovies
                    }
                ]
            } else {
                newOptions[id] = [defaultFilterValue]
                const data = relevantAttributes[id]

                if(!isEmptyObj(data)) {
                    const sortedOptionsKeys = getSortItems('name', 'alphabetical', Object.keys(data), data)
                    sortedOptionsKeys.map(key => newOptions[id].push(data[key]))
                }
            }
            
        })

        setFilterOptions(newOptions)
    }, [relevantAttributes, currentMovies, futureMovies])

    const onAction = (values) => {
        if((hasTargetOptions && !values.target.pk) || !values.action.id || !values.filter) {
            return
        }

        const isAddItems = 'add' === values.action.id
        const args = []
        
        filterConfig.map(({id}) => {
            const filterValues = values.filter[id]

            if(!(filterValues.hasOwnProperty('id') &&  'all' === filterValues.id)) {
                args.push(filterValues.movies)
            }
        })

        if(isAddItems) {
            args.push(relevantMovies)
        } else {
            args.push(hasTargetOptions ? selectedItems[values.target.pk] : selectedItems)
        }

        const itemIds = _.intersection(...args)

        if(0 === itemIds.length) {
            return
        }

        const targetId = hasTargetOptions ? values.target.pk : null
       
        itemIds.map(itemId => isAddItems ? addItem(listId, itemId, targetId) : deleteItem(listId, itemId, targetId))
    } 

    return <MoviesFilterActions
        filterConfig={filterConfig}
        filterOptions={filterOptions}
        targetOptions={dropStructureData}
        actionOptions={actionOptions}
        onAction={onAction}
    />
}

export default MoviesFilterActionsContainer
